<template>
  <transition name="fadeTooltip">
    <div v-show="visible">
      <div class="tooltip" v-bind:x-placement="placement">
        <div class="tooltip__icon-wrap p-2">
          <dynamic-icon icon="info"></dynamic-icon>
        </div>
        <div class="tooltip__text-wrap p-2" v-html="text"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      text: null,
      placement: "right",
      visible: false
    };
  }
};
</script>
